// The one USD formatter: always "$5.00" (a dot and two decimals), whatever the browser's language or region.
export const usd = (n, digits = 2) => `$${Number(n || 0).toFixed(digits)}`;
